
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"40","height":"40","viewBox":"0 0 40 40","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M16.7 19.9l6.9-6.9c.6-.6.2-3.7-.7-2.7l-8.2 8.2c-.5.5-.5 2.2 0 2.7l8.3 8.3c.9.9 1.3-2.1.7-2.7-2.4-2.3-4.7-4.6-7-6.9z"}}),_c('path',{attrs:{"d":"M19.7 4C0 3.9.2 34.8 19.7 35.8c19.4-1 19.6-31.7 0-31.8zm0 28.6c-6.9-.3-13.6-5.2-13.6-12.7 0-7.2 6.7-12.7 13.6-12.7 6.5 0 14.1 5.5 13.6 12.7-.5 7.5-6.4 12.4-13.6 12.7z"}})])
          )
        }
      }
    